"use client";

import getMinifyCSS from "@litonarefin/utils/getMinifyCSS";
import { getCleanSpacing } from "@litonarefin/utils/spacing";
import { usePathname } from "next/navigation";

export default function Video({ attributes }) {
  const pathname = usePathname();

  return (
    <figure {...(attributes?.anchor && { id: attributes?.anchor })} className="jlt-video-wrapper">
      <video
        id={attributes?.id}
        controls={attributes?.jltControls}
        preload={attributes?.preload}
        // onContextMenu="return false;"
        className="jlt-webm-video"
        src={attributes?.src}
        poster={attributes?.metadata?.thumbnail_url}
        playsInline={attributes?.jltPlayInline ? true : false}
        autoPlay={attributes?.jltAutoPlay ? true : false}
        muted={attributes?.jltMuted}
        loop={attributes?.jltLoop ? true : false}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
                      "@context": "https://schema.org",
                      "@type": "VideoObject",
                      "name": "${attributes?.metadata?.title}",
                      "description": "${attributes?.metadata?.description}",
                      "thumbnailUrl": "${attributes?.metadata?.thumbnail_url}",
                      "uploadDate": "${attributes?.metadata?.upload_date}",
                      "duration": "${attributes?.metadata?.duration}",
                      "contentUrl": "${attributes?.src}",
                      "embedUrl": "${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}",
                      "publisher": {
                        "@type": "Organization",
                        "name": "${process.env.NEXT_PUBLIC_SOURCE_SITE}",
                        "logo": {
                          "@type": "ImageObject",
                          "url": "${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}/logo.svg",
                          "width": 156,
                          "height": 28
                        }
                      }
                    }`,
        }}
      />
      <style jsx>{`
        .jlt-video-wrapper {
          ${getMinifyCSS(`
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.top)
                            ? `margin-top: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.top
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.bottom)
                            ? `margin-bottom: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.bottom
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.left)
                            ? `margin-left: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.left
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.right)
                            ? `margin-right: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.right
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.top)
                            ? `padding-top: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.top
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.bottom)
                            ? `padding-bottom: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.bottom
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.left)
                            ? `padding-left: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.left
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.right)
                            ? `padding-right: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.right
                              )};`
                            : ""
                        }
                    `)}
        }
      `}</style>
    </figure>
  );
}
